module.exports = __webpack_public_path__ + "static/media/step2.e51096e5.png";